import { render, staticRenderFns } from "./CarService.vue?vue&type=template&id=13c5a3cc&scoped=true"
import script from "./CarService.vue?vue&type=script&lang=js"
export * from "./CarService.vue?vue&type=script&lang=js"
import style0 from "./CarService.vue?vue&type=style&index=0&id=13c5a3cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c5a3cc",
  null
  
)

export default component.exports